import { render, staticRenderFns } from "./WorkshopList.vue?vue&type=template&id=dbfa6afa&scoped=true&"
import script from "./WorkshopList.vue?vue&type=script&lang=js&"
export * from "./WorkshopList.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopList.vue?vue&type=style&index=0&id=dbfa6afa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfa6afa",
  null
  
)

export default component.exports